import { render } from "./DadosBancarios.vue?vue&type=template&id=94c3c5b0&scoped=true"
import script from "./DadosBancarios.vue?vue&type=script&lang=js"
export * from "./DadosBancarios.vue?vue&type=script&lang=js"

import "./DadosBancarios.vue?vue&type=style&index=0&id=94c3c5b0&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-94c3c5b0"]])

export default __exports__